import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance9000 } from "../../../api/axiosInstance";

export const fetchClaimReport = createAsyncThunk(
  'claim/fetchReportClaim',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance9000.get(`/api/headoffice/claim/report/detail?id=${id}`);
      return response.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const claimSlice = createSlice({
  name: 'claims',
  initialState: {
    data: null,
    isLoading: false,
    isError: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClaimReport.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(fetchClaimReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchClaimReport.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      });
  },
});

export default claimSlice.reducer;
